<template>
  <path 
    d="M22.9938 15.3301C18.7705 15.3301 15.324 18.7766 15.324 23C15.324 27.2234 18.7705 30.6699 22.9938 30.6699C27.2171
    30.6699 30.6636 27.2234 30.6636 23C30.6636 18.7766 27.2171 15.3301 22.9938 15.3301ZM45.9974 23C45.9974 19.8239 46.0262 
    16.6765 45.8478 13.5061C45.6695 9.8236 44.8294 6.55539 42.1366 3.86257C39.4381 1.164 36.1757 0.329683 32.4933 0.151312C29.3172
    -0.0270581 26.1699 0.00171146 22.9996 0.00171146C19.8235 0.00171146 16.6762 -0.0270581 13.5058 0.151312C9.82341 0.329683 6.55527 
    1.16975 3.8625 3.86257C1.16398 6.56114 0.329677 9.8236 0.15131 13.5061C-0.0270576 16.6822 0.00171143 19.8296 0.00171143 23C0.00171143
    26.1704 -0.0270576 29.3235 0.15131 32.4939C0.329677 36.1764 1.16973 39.4446 3.8625 42.1374C6.56102 44.836 9.82341 45.6703 13.5058 
    45.8487C16.6819 46.0271 19.8292 45.9983 22.9996 45.9983C26.1757 45.9983 29.323 46.0271 32.4933 45.8487C36.1757 45.6703 39.4439 
    44.8302 42.1366 42.1374C44.8352 39.4389 45.6695 36.1764 45.8478 32.4939C46.032 29.3235 45.9974 26.1761 45.9974 23ZM22.9938 
    34.8012C16.4633 34.8012 11.1928 29.5307 11.1928 23C11.1928 16.4693 16.4633 11.1988 22.9938 11.1988C29.5244 11.1988 34.7948 
    16.4693 34.7948 23C34.7948 29.5307 29.5244 34.8012 22.9938 34.8012ZM35.2781 13.4716C33.7534 13.4716 32.5221 12.2402 32.5221 
    10.7155C32.5221 9.19067 33.7534 7.95934 35.2781 7.95934C36.8029 7.95934 38.0342 9.19067 38.0342 10.7155C38.0347 11.0775 37.9637 
    11.4361 37.8253 11.7707C37.687 12.1053 37.484 12.4093 37.228 12.6653C36.972 12.9213 36.668 13.1243 36.3334 13.2627C35.9988 13.401 
    35.6402 13.472 35.2781 13.4716Z" 
  />
</template>

<script>
export default {

}
</script>

<style scoped>
    path {
        font-family: var(--iconFontFamily);
        font-size: var(--iconFontSize);
        fill: var(--iconTextColor);
        stroke: var(--iconBorderColor)
    }
</style>